import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=25706f25&"
import script from "./VideoView.vue?vue&type=script&lang=ts&"
export * from "./VideoView.vue?vue&type=script&lang=ts&"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=25706f25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports